import { Injectable } from '@angular/core';
import { of, map, forkJoin, tap } from 'rxjs';
import { HttpService } from '../../../core/services/http.service';
import { Site } from '../../models/site';

@Injectable({
  providedIn: 'root',
})
export class SitesHttpService {
  private _sitesActive: Site[] = [];
  private _sites: Site[] = [];

  constructor(private http: HttpService) {}

  getMonSite(siteId: number) {
    const requetes = [this.http.get<Site>('Sites/' + siteId)];
    return forkJoin(requetes).pipe(
      tap((resultats) => {
        let site = resultats[0] as Site;
        return site;
      }),
    );
  }

  getSitesAcitve() {
    if (this._sitesActive.length > 0) return of(this._sitesActive);

    return this.http.get<Site[]>('Sites/Active').pipe(
      map((result) => {
        this._sitesActive = result;
        return result;
      }),
      // shareReplay(1)
    );
  }

  getSites() {
    if (this._sites.length > 0) return of(this._sites);

    return this.http.get<Site[]>('Sites').pipe(
      map((response) => {
        this._sites = response;
        return response;
      }),
    );
  }


}
